<template>
  <div class="abs-testo" v-if="$abs.row.pa>-1">

    <div style="color:red;" v-if="false">Tipoeditor {{typeof $teras.evento.tipoeditor}} » {{$teras.evento.allegato}}   </div>
    <el-form-item   :label="$teras.lang.titolo" prop="titolo">
      <el-input :placeholder="$teras.lang.titoloHolder" v-model="$abs.row.titolo"></el-input>
    </el-form-item>

    <el-form-item :label="$teras.lang.testo" v-if="(typeof $teras.evento.tipoeditor != 'undefined')">
        <tinymce v-model="$abs.row.testo" :initvalue="$abs.row.testo" height="300" :language="$teras.language" v-on:change="testoChange"> </tinymce>
    </el-form-item>

    <div class="row pad help">
      <div class="col s2 yo-align-right"><i class="material-icons">live_help</i></div>
      <div class="col s10" v-html="$teras.lang.datitestoHelp"></div>
    </div>

    <div class="row pad help" v-if="$abs.row.wordcount>$teras.evento.maxparole" style="color:red">
      <div class="col s2 yo-align-right"><i class="material-icons" >warning</i></div>
      <div class="col s10 " >
          {{$teras.lang.maxparoleWarning}}: {{$teras.evento.maxparole}}  
      </div>
    </div>

    <el-form-item v-if="$teras.evento.parolechiave==1"  :label="$teras.lang.parolechiave" prop="parolechiave">
      <el-input :placeholder="$teras.lang.parolechiaveHolder" v-model="$abs.row.parolechiave"></el-input>
    </el-form-item>

    <div class="row help" v-if="$teras.evento.allegato==1">
    <div class="col s2 yo-align-right"><label for="allegato" class="el-form-item__label" style="width:100% !important">{{$teras.lang.allegato}}</label></div>
      <upload class="col s10" 
      :value="$abs.row.allegato" 
      v-on:change="val => $abs.row.allegato=val" 
      v-on:success="imageSuccess" 
      action="https://api.biomedia.net/201806/vue/upload/" 
      :savedir="'bvent.biomedia.net/abstracts/'+$teras.evento.id+'/'" 
      :previewurl="'https://bvent.biomedia.net/abstracts/'+$teras.evento.id+'/'" 
      extensions="png,PNG,jpg,JPG,jpeg,JPEG"></upload>
    </div>
    

  </div>
</template>

<script>
import upload from './Upload.vue'
import tinymce from './Page-tinymce.vue'
export default {
  name: 'abs-primoautore',
  components: {
      tinymce,
      upload
  },
  created () {
    console.log("Arrivo al abs-testo.vue");
  },
  methods: {
    imageSuccess() {
      //this.doUpdate()
      this.$notify.success({type: 'info',message: 'Image allegata correttamente', duration:5000})    
        
    },
    testoChange(new_value, wordCount){
      console.log(new_value)
      console.log(wordCount)
      this.$abs.row.wordcount = wordCount
    }
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// Abs-testo.vue?734cd68a